import { GET_RESE_BMS_TABLE_DATA, GET_RESE_BMS_TABLE_DANFOSS_VERSION_FIRMWARE, GET_RESE_BMS_TABLE_EMERSON_VERSION_FIRMWARE, GET_RESE_BMS_TABLE_STATUS, UPDATE_RESE_BMS_TABLE_DATA } from "./actionTypes";

export const getReseBmsTableDataInit = (pageNumber, pageSize, sortBy, sortDirection, filterCondition) => ({
    type: GET_RESE_BMS_TABLE_DATA.INIT,
    pageNumber, pageSize, sortBy, sortDirection, filterCondition
});

export const getReseBmsTableDataSuccess = (reseBmsTableData) => ({
    type: GET_RESE_BMS_TABLE_DATA.SUCCESS,
    payload: reseBmsTableData
});

export const getReseBmsTableDataError = (error) => ({
    type: GET_RESE_BMS_TABLE_DATA.ERROR,
    payload: error
});

export const getReseBmsTableDanfossVersionFirmwareInit = (brandName) => ({
    type: GET_RESE_BMS_TABLE_DANFOSS_VERSION_FIRMWARE.INIT,
    brandName
});

export const getReseBmsTableDanfossVersionFirmwareSuccess = (reseBmsTableDanfossVersionFirmwareValues) => ({
    type: GET_RESE_BMS_TABLE_DANFOSS_VERSION_FIRMWARE.SUCCESS,
    payload: reseBmsTableDanfossVersionFirmwareValues
});

export const getReseBmsTableDanfossVersionFirmwareError = (error) => ({
    type: GET_RESE_BMS_TABLE_DANFOSS_VERSION_FIRMWARE.ERROR,
    payload: error
});

export const getReseBmsTableEmersonVersionFirmwareInit = (brandName) => ({
    type: GET_RESE_BMS_TABLE_EMERSON_VERSION_FIRMWARE.INIT,
    brandName
});

export const getReseBmsTableEmersonVersionFirmwareSuccess = (reseBmsTableEmersonVersionFirmwareValues) => ({
    type: GET_RESE_BMS_TABLE_EMERSON_VERSION_FIRMWARE.SUCCESS,
    payload: reseBmsTableEmersonVersionFirmwareValues
});

export const getReseBmsTableEmersonVersionFirmwareError = (error) => ({
    type: GET_RESE_BMS_TABLE_EMERSON_VERSION_FIRMWARE.ERROR,
    payload: error
});

export const getReseBmsTableStatusInit = (statusColumnPayload) => ({
    type: GET_RESE_BMS_TABLE_STATUS.INIT,
    statusColumnPayload
});

export const getReseBmsTableStatusSuccess = (reseBmsTableStatusValues) => ({
    type: GET_RESE_BMS_TABLE_STATUS.SUCCESS,
    payload: reseBmsTableStatusValues
});

export const getReseBmsTableStatusError = (error) => ({
    type: GET_RESE_BMS_TABLE_STATUS.ERROR,
    payload: error
});


export const updateReseBmsTableDataInit = (resebmstableData) => ({
    type: UPDATE_RESE_BMS_TABLE_DATA.INIT,
    resebmstableData
});

export const updateReseBmsTableDataSuccess = (tableDataUpdateMessage) => ({
    type: UPDATE_RESE_BMS_TABLE_DATA.SUCCESS,
    payload: tableDataUpdateMessage
});

export const updateReseBmsTableDataError = (tableDataUpdateErrorMessage) => ({
    type: UPDATE_RESE_BMS_TABLE_DATA.ERROR,
    payload: tableDataUpdateErrorMessage
});





